var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAv5Indicative = function SvgAv5Indicative(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.126 1v8.253M2.208 2.209l5.837 5.836M8.045 2.209 2.209 8.045",
    stroke: "#9B9AC8",
    strokeWidth: 1.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    "data-no-fill": "true"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 5.127h8.253",
    stroke: "#9B9AC8",
    strokeWidth: 1.297,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    "data-no-fill": "true"
  })));
};
export { SvgAv5Indicative as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMTAgMTAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICA8cGF0aCBkPSJNNS4xMjY0NiAxVjkuMjUzNDciIHN0cm9rZT0iIzlCOUFDOCIgc3Ryb2tlLXdpZHRoPSIxLjMiIHN0cm9rZS1taXRlcmxpbWl0PSIxMCIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBkYXRhLW5vLWZpbGw9InRydWUiLz4KICAgIDxwYXRoIGQ9Ik0yLjIwODUgMi4yMDg3NEw4LjA0NDU4IDguMDQ0ODMiIHN0cm9rZT0iIzlCOUFDOCIgc3Ryb2tlLXdpZHRoPSIxLjMiIHN0cm9rZS1taXRlcmxpbWl0PSIxMCIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBkYXRhLW5vLWZpbGw9InRydWUiLz4KICAgIDxwYXRoIGQ9Ik04LjA0NDY4IDIuMjA4NzRMMi4yMDg1OSA4LjA0NDgzIiBzdHJva2U9IiM5QjlBQzgiIHN0cm9rZS13aWR0aD0iMS4zIiBzdHJva2UtbWl0ZXJsaW1pdD0iMTAiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgZGF0YS1uby1maWxsPSJ0cnVlIi8+CiAgICA8cGF0aCBkPSJNMSA1LjEyNjk1SDkuMjUzNDciIHN0cm9rZT0iIzlCOUFDOCIgc3Ryb2tlLXdpZHRoPSIxLjI5Njg1IiBzdHJva2UtbWl0ZXJsaW1pdD0iMTAiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgZGF0YS1uby1maWxsPSJ0cnVlIi8+Cjwvc3ZnPgo=";